/**
 * Pre-paint gate for SmartAppBanner.
 *
 * The banner used to mount after hydration at the very top of the page and
 * push everything 68px down on every phone visit. Search Console (5 Oct 2026)
 * had 4,015 mobile URLs failing CLS, and a live layout-shift trace put the
 * shift on exactly that insertion.
 *
 * Now the banner renders with the server HTML, and this script — inlined in
 * <head>, so it runs before first paint — marks the document when the banner
 * must not show: dismissed in the last 30 days, inside the app's WebView,
 * iOS Safari (which shows Apple's Smart App Banner instead), or not an
 * iOS/Android browser. The CSS hides it before it is ever drawn. Same
 * banner, no shift.
 *
 * Plain module (not 'use client') because the server layout reads these.
 */
import { IOS_OTHER_BROWSER_RE, IOS_RE, SAFARI_RE } from './appInstall';

export const APP_BANNER_DISMISS_KEY = 'campingaustralia.smartAppBanner.dismissedUntil';

export const APP_BANNER_GATE_SCRIPT = `try{var u=navigator.userAgent,v=localStorage.getItem(${JSON.stringify(
  APP_BANNER_DISMISS_KEY,
)});if(/CampingAustralia\\//.test(u)||!/iPhone|iPod|iPad|Android/i.test(u)||(/${IOS_RE.source}/i.test(u)&&/${SAFARI_RE.source}/.test(u)&&!/${IOS_OTHER_BROWSER_RE.source}/.test(u))||(v&&+v>Date.now()))document.documentElement.setAttribute('data-app-banner','off')}catch(e){}`;

export const APP_BANNER_GATE_CSS = `html[data-app-banner="off"] .smart-app-banner{display:none}`;
